const routeAbout = "/about";
const routeAboutOverview = `${routeAbout}#overview`;
const routeAboutWhy = `${routeAbout}#why-datadesc`;
const routeAboutTeam = `${routeAbout}#team`;
const routeAboutStatistics = `${routeAbout}#statistics`;

const routeSubAnnotate = "annotate";
const routeSubSchema = "schema";
const routeSubTechnical = "technical";
const routeSubGeneral = "general";
const routeSubCompare = "compare";
const routeSubMerge = "merge";
const routeSubPublish = "publish";
const routeSubGitHub = "github";

const routeDashboard = "/d";
const routeAnnotationTools = `${routeDashboard}/${routeSubAnnotate}`;
const routePublicationTools = `${routeDashboard}/${routeSubPublish}`;

const routeResodate = "/resodate";

export const routes = {
  home: "/",
  about: routeAbout,
  aboutOverview: routeAboutOverview,
  aboutWhy: routeAboutWhy,
  aboutTeam: routeAboutTeam,
  aboutStatistics: routeAboutStatistics,
  resodate: routeResodate,
  dashboard: routeDashboard,
  schema: {
    absolute: `${routeDashboard}/${routeSubSchema}`,
    relative: routeSubSchema,
  },
  schemaArchive: {
    absolute: `${routeDashboard}/${routeSubSchema}/archive`,
    relative: `${routeSubSchema}/archive`,
  },
  vocabulary: {
    absolute: "/terms/",
  },
  // ANNOTATE
  annotationTools: {
    absolute: routeAnnotationTools,
    relative: routeSubAnnotate,
  },
  annotationTechnical: {
    absolute: `${routeAnnotationTools}/${routeSubTechnical}`,
    relative: routeSubTechnical,
  },
  annotationGeneral: {
    absolute: `${routeAnnotationTools}/${routeSubGeneral}`,
    relative: routeSubGeneral,
  },
  compareMetadata: {
    absolute: `${routeAnnotationTools}/${routeSubCompare}`,
    relative: routeSubCompare,
  },
  mergeMetadata: {
    absolute: `${routeAnnotationTools}/${routeSubMerge}`,
    relative: routeSubMerge,
  },
  // PUBLISH
  publicationTools: {
    absolute: routePublicationTools,
    relative: routeSubPublish,
  },
  publishGitHub: {
    absolute: `${routePublicationTools}/${routeSubGitHub}`,
    relative: routeSubGitHub,
  },
  // LEGAL PAGES
  imprint: "/imprint",
  privacyPolicy: "/privacy-policy",
  acknowledgement: "/acknowledgement",
};
